<!-- <p class="version-tag">version : {{ versionName }}</p> -->
<footer class="d-flex justify-content-around flex-wrap py-2 border-top">
  <p class="m-0 text-muted version-font">©{{ "OurCompany" | translate }}</p>
  <p class="m-0 text-muted version-font">v {{ versionName }}</p>
  <p class="m-0 text-muted version-font">
    {{ showDate }}
  </p>
</footer>
